import PropTypes from 'prop-types'

export default function Progress({ progress = 0, className = '' }) {
  // Clamp progress between 0 and 100
  const clampedProgress = Math.min(Math.max(progress, 0), 100)

  return (
    <div
      className={`h-[6px] w-[150px] overflow-hidden rounded-[6px] bg-softGrey ${className}`}
    >
      <div
        className='h-full rounded-[6px] bg-primaryGreen transition-all duration-300 ease-out'
        style={{ width: `${clampedProgress}%` }}
      />
    </div>
  )
}

Progress.propTypes = {
  progress: PropTypes.number,
  className: PropTypes.string
}
